import React from 'react'

// see: https://itnext.io/4ce9df693dd
export const useCombinedRefs = (...refs) => {
  const targetRef = React.useRef(null)

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}
